import { LoadableBackground } from '@confluence/loadable';

export const ExternalCollaboratorInSpaceNotify = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExternalCollaboratorInSpaceNotifyExternalCollaboratorInSpaceNotify" */ '../src/ExternalCollaboratorInSpaceNotify/ExternalCollaboratorInSpaceNotify'
			)
		).ExternalCollaboratorInSpaceNotify,
});
